export default (serviceHandle, createdFetech = true, insetparams = {}, pageSizeChange = false) => ({
  data() {
    return {
      pages: {
        pageNo: 1,
        pageSize: insetparams.pageSize || 15
      },
      step: insetparams.pageSize || 15,
      total: null,
      list: [],
      finish: Function
    }
  },
  created() {
    if (createdFetech) this.handleFetch()
  },
  methods: {
    _refresh({ finish }) { // 刷新
      if (finish) this.finish = finish
      if (pageSizeChange) {
        this.pages.pageSize = this.step * 1
      } else {
        this.pages.pageNo = 1
      }
      this.handleFetch()
    },

    _loadmore({ finish }) { // 加载更多
      if (finish) this.finish = finish
      if (this.pages.pageNo * this.pages.pageSize >= this.total) {
        this.$vux.toast.show({ text: this.$t('others').noData1, type: 'text' });
        this.finish()
        return
      }
      if (pageSizeChange) {
        this.pages.pageSize += this.step * 1
      } else {
        this.pages.pageNo += 1
      }
      this.handleFetch()
    },

    getparams() { // 获取参数
      return {}
    },

    handleFetch() {
      if (pageSizeChange && insetparams.pageSize) delete insetparams.pageSize
      const params = { ...this.pages, ...this.getparams(), ...insetparams }
      serviceHandle(params).then(([data, err, res]) => {
        this.finish()
        if (!err) {
          console.log('data');
          console.log(data);
          console.log(res);
          if (data.list) {
            const { total, list } = data || res.data
            this.total = total
            if (pageSizeChange) {
              console.log('list===');
              console.log(list);
              this.list = list
            } else {
              this.list = this.pages.pageNo === 1 ? list : [...this.list, ...list]
            }
          }
          if(data.info && data.info.list){
            const { total, list } = data.info || res.data.info
            this.total = total
            if (pageSizeChange) {
              this.list = list
            } else {
              this.list = this.pages.pageNo === 1 ? list : [...this.list, ...list]
            }
          }
        } else {
          if (pageSizeChange || (!pageSizeChange && this.pages.pageNo === 1)) {
            this.total = 0
            this.list = []
          }
        }
        this.$store.commit('updateLoadingStatus', { isLoading: false })
        if (this.$store.state.pageLoading) this.$store.commit('setPageLoading', false)
        this.implementationFetched([data, err, res])
      })
    },

    implementationFetched([data, err, res]) {}
  }
})



// WEBPACK FOOTER //
// ./src/common/mixin/loadmorelist.js